module.exports = __webpack_public_path__ + "static/media/DSCF0420-iYvoiYgs.e82cf36b.JPG";